var map = {
	"./rarity1.png": "./src/views/official/resources/images/warehouse/rarity1.png",
	"./rarity2.png": "./src/views/official/resources/images/warehouse/rarity2.png",
	"./rarity3.png": "./src/views/official/resources/images/warehouse/rarity3.png",
	"./rarity4.png": "./src/views/official/resources/images/warehouse/rarity4.png",
	"./rarity5.png": "./src/views/official/resources/images/warehouse/rarity5.png",
	"./rarity6.png": "./src/views/official/resources/images/warehouse/rarity6.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/views/official/resources/images/warehouse sync recursive ^\\.\\/rarity.*\\.png$";